<script>
  import options from './AttachmentsViewer.options'
  export default options
</script>

<template>
  <article class="kb-community-attachments-viewer">
    
    <template v-for="file, index in files" :key="index">

      <a v-if="isDocument(file)" :href="file.url" class="kb-create-post__files-content-wrapper" target="_blank">
        <div class="kb-create-post__files-content-wrapper-left">
          <div v-html="getDocumentIcon(file)"> </div>                        
        </div>
        <div class="kb-create-gallery__files-content-wrapper-right">
          <div class="kb-create-gallery__files-details-wrapper">
            <span>{{ file.filename }}</span>
          </div>                      
        </div>
      </a>

      <figure v-else class="kb-image-module kb-image-module--4-3">
        <div class="kb-image-module__image-container">
          <picture  class="kb-image-module__image">
            <source :srcset="file.url" media="(min-width:1024px)">
            <source :srcset="file.url" media="(min-width: 768px)">
            <source :srcset="file.url" media="(min-width: 376px)">
            <source :srcset="file.url" media="(max-width: 376px)">
            <img :src="file.url" :alt="file.altText">
          </picture>
        </div>
      </figure>

    </template>

  </article>
</template>
